export const GET_JUNIOR_HANDLING_RESULT_FILES = "GET_JUNIOR_HANDLING_RESULT_FILES";
export const GET_JUNIOR_HANDLING_RESULT_FILES_SUCCESS = "GET_JUNIOR_HANDLING_RESULT_FILES_SUCCESS";
export const GET_JUNIOR_HANDLING_RESULT_FILES_FAIL = "GET_JUNIOR_HANDLING_RESULT_FILES_FAIL";


export const ADD_JUNIOR_HANDLING_EVENT_FILE="ADD_JUNIOR_HANDLING_EVENT_FILE";
export const ADD_JUNIOR_HANDLING_EVENT_FILE_SUCCESS="ADD_JUNIOR_HANDLING_EVENT_FILE_SUCCESS";
export const ADD_JUNIOR_HANDLING_EVENT_FILE_FAILURE="ADD_JUNIOR_HANDLING_EVENT_FILE_FAILURE";

export const DEL_JUNIOR_HANDLING_DISPLAY_EVENT_FILE="DEL_JUNIOR_HANDLING_DISPLAY_EVENT_FILE";
export const DEL_JUNIOR_HANDLING_DISPLAY_EVENT_FILE_SUCCESS="DEL_JUNIOR_HANDLING_DISPLAY_EVENT_FILE_SUCCESS";
export const DEL_JUNIOR_HANDLING_DISPLAY_EVENT_FILE_FAILURE="DEL_JUNIOR_HANDLING_DISPLAY_EVENT_FILE_FAILURE";

export const GET_JUNIOR_HANDLING_FILE_RESULTS="GET_JUNIOR_HANDLING_FILE_RESULTS";
export const GET_JUNIOR_HANDLING_FILE_RESULTS_SUCCESS="GET_JUNIOR_HANDLING_FILE_RESULTS_SUCCESS";
export const GET_JUNIOR_HANDLING_FILE_RESULTS_FAIL="GET_JUNIOR_HANDLING_FILE_RESULTS_FAIL";

export const GET_JUNIOR_EVENT_ATTENDEE_RESULTS = "GET_JUNIOR_EVENT_ATTENDEE_RESULTS";
export const GET_JUNIOR_EVENT_ATTENDEE_RESULTS_SUCCESS = "GET_JUNIOR_EVENT_ATTENDEE_RESULTS_SUCCESS";
export const GET_JUNIOR_EVENT_ATTENDEE_RESULTS_FAIL = "GET_JUNIOR_EVENT_ATTENDEE_RESULTS_FAIL";
